module.exports = __webpack_public_path__ + "img/guyana.3b9d4f3.webp";